import React from 'react';
import { motion } from 'framer-motion';
import procurementData from '../data/ProcurementData';
import Correct from '../assets/correct.svg'; 
import '../styles/procurement.css';
import ProcurementImage from '../assets/nextcastle-procurement.jpg';
import Footer from '../components/Footer';
import ProcurementProcessData from '../data/ProcurementProcessData';
import Call from '../components/Call';

const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 1 } },
};

const slideIn = {
  hidden: { x: -100, opacity: 0 },
  visible: { x: 0, opacity: 1, transition: { duration: 1 } },
};

const staggerContainer = {
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.3 },
  },
};

function Procurement() {
  return (
    <div className='procurement-container'>
      {/* Hero Section */}
      <motion.div className="procurement-hero" variants={fadeIn} initial="hidden" animate="visible">
        <h1>Our Procurement Services</h1>
        <p>At NEXTCASTLE ENERGY LIMITED, our Procurement Services are designed to provide cost-effective, high-quality, and timely supply solutions for the oil and gas industry...</p>
      </motion.div>

      {/* Procurement Capabilities */}
      <motion.div className="procurement-services" variants={staggerContainer} initial="hidden" animate="visible">
        <div className="procurement-service-text">
          <h2>Our Procurement Capabilities</h2>
        </div>
        <div className="procurement-service-cards">
          {procurementData.map((item, index) => (
            <motion.div key={index} className="procurement-card" variants={fadeIn}>
              <div className="title"><h2>{item.title}</h2></div>
              <div className="desc"><p>{item.description}</p></div>
              <div className="list">
                {item.services.map((service, i) => (
                  <div key={i} className="service">
                    <img src={Correct} alt="correct-icon" />
                    <p>{service}</p>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>

      {/* Why Choose Us Section */}
      <motion.div className="why-choose-us-container" variants={slideIn} initial="hidden" animate="visible">
        <div className="why-choose-us-image">
          <img src={ProcurementImage} alt="nextcastle-why-choose-us" />
        </div>
        <div className="why-choose-us-text">
          <h2>Why Choose <span>NEXTCASTLE ENERGY LIMITED</span> for Procurement?</h2>
          <ul>
            <li><span>Industry Compliance: </span>All procured materials comply with international oil and gas standards.</li>
            <li><span>Global Supplier Network: </span>We ensure the best quality at the most competitive price.</li>
            <li><span>On-Time Delivery: </span>Fast and efficient delivery to project sites.</li>
            <li><span>Cost-Effective Solutions: </span>Minimize costs without compromising quality.</li>
            <li><span>Customization & Flexibility: </span>Tailored procurement solutions.</li>
            <li><span>Sustainable Procurement: </span>Eco-friendly sourcing practices.</li>
          </ul>
        </div>
      </motion.div>

      {/* Procurement Process */}
      <motion.div className="procurement-process-container" variants={staggerContainer} initial="hidden" animate="visible">
        <div className="procurement-process-text">
          <h2>Our Procurement Process</h2>
        </div>
        <div className="procurement-process-card">
          {ProcurementProcessData.map((item, index) => (
            <motion.div key={index} className="process-card" variants={fadeIn}>
              <h2>{item.title}</h2>
              <p>{item.content}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>

      <Call/>
      <Footer/>
    </div>
  );
}

export default Procurement;